import { createContext } from 'react';

export const ExportDetectionsContext =
    createContext<ExportDetectionsProviderValue>({
        exportDetections: () => Promise.resolve(true),
        exportingDetections: [],
    });
